import * as React from 'react';
import { connect } from 'react-redux';
import { RouterState } from 'connected-react-router';
import { parse } from 'qs';
import { isEqual as _isEqual } from 'lodash';
import { history } from '../../../redux/store.redux';

import { 
  QueryParameterState, 
  cleanSearchQuery, 
  QueryParemeterQsParse, 
  changeQueryParams,
  queryParameterInitialState,
  filterComparativeParameter,
  clearQueryParams,
} from '../../../api';
import { LocationDescriptorObject } from 'history';

export interface QueryParamsDispatcherProps {
  dispatch: any;
  location: RouterState['location'];
  params: QueryParameterState['params'];
  searchQuery: QueryParameterState['search'];
}

export class QueryParamsDispatcherComponent extends React.Component<QueryParamsDispatcherProps> {

  componentDidMount() {
    if (this.queryParameter) {
      this.parseQueryParameter();
    }
  }

  componentDidUpdate(prevProps: QueryParamsDispatcherProps) {
    const { location, searchQuery } = this.props;

    if (!location || !prevProps.location) { return; }
    if (location.search !== prevProps.location.search) {
      this.parseQueryParameter();
    }
    
    if (searchQuery !== prevProps.searchQuery) {
      const locationToPush: LocationDescriptorObject = location;
      locationToPush.search = searchQuery || '';

      history.push(locationToPush);
    }
  }

  componentWillUnmount() {
    this.props.dispatch(clearQueryParams());
  }

  public render() {
    return null;
  }

  private get queryParameter(): QueryParemeterQsParse {
    const { location } = this.props;
    const search = cleanSearchQuery(location.search);
    return filterComparativeParameter(parse(search), Object.keys(queryParameterInitialState.params));
  }

  private parseQueryParameter() {
    const parsedParams = this.queryParameter;
    this.props.dispatch(changeQueryParams(parsedParams));
  }
}

interface StateProps {
  router: RouterState;
  queryState: QueryParameterState;
}

export const QueryParamsDispatcher = connect((state: StateProps) => ({
  location: state.router.location,
  params: state.queryState.params,
  searchQuery: state.queryState.search,
}))(QueryParamsDispatcherComponent);

export default QueryParamsDispatcher;